import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import ConnectionBanner from './components/ConnectionBanner';
import Login from './pages/Login';
import {isTokenValid} from './api';
import TenantSelector from './pages/TenantSelector';
import Dashboard from './pages/Dashboard';
import Timesheets from './pages/Timesheets';
import TimesheetDetail from './pages/TimesheetDetail';
import Profile from './pages/Profile';
import SelfMapping from './pages/SelfMapping';

function ProtectedRoute({ children }) {
  const location = useLocation();
  return isTokenValid() ? children : <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
}

function TenantRequiredRoute({ children }) {
  const location = useLocation();
  if (!isTokenValid()) return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  const hasTenant = document.cookie.split(';').some(c => c.trim().startsWith('tenantId='));
  if (!hasTenant) return <Navigate to={`/tenants?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
}

export default function App() {
  return (
    <Router>
      <ConnectionBanner />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/tenants" element={<ProtectedRoute><TenantSelector /></ProtectedRoute>} />
        <Route path="/" element={<TenantRequiredRoute><Dashboard /></TenantRequiredRoute>} />
        <Route path="/timesheets" element={<TenantRequiredRoute><Timesheets /></TenantRequiredRoute>} />
        <Route path="/timesheets/:id" element={<TenantRequiredRoute><TimesheetDetail /></TenantRequiredRoute>} />
        <Route path="/profile" element={<TenantRequiredRoute><Profile /></TenantRequiredRoute>} />
        <Route path="/self-map" element={<TenantRequiredRoute><SelfMapping /></TenantRequiredRoute>} />
      </Routes>
    </Router>
  );
}
